import React, { Component } from 'react';
import golbeldata from '../data.json';
import Appnav from './Appnav.js'
import AppFooter from './Footer.js'
import AppTopHeader from './AppTopHeader.js'
import { Link, Route, Switch } from 'react-router-dom';

class Explore extends Component {
    constructor(props) {
        super(props);

        this.concerts = golbeldata;
    }

    componentDidMount() {

        document.title = this.concerts.HotelName+" Explore";
        //concerts: golbeldata
    }

    render() {
        console.log(this.concerts.Explore);
        return (
            <div>
                <AppTopHeader data={this.concerts} />
                <header>
                    <Appnav data={this.concerts} />
                </header>
                <section class="parallax-effect">
                    <div id="parallax-pagetitle" style={{ backgroundImage: 'url("images/parallax/' + this.concerts.parllex + '")' }}>
                        <div class="color-overlay">

                            <div class="container">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <ol class="breadcrumb">
                                            <li><a href="index.html">Home</a></li>
                                            <li class="active">Explore</li>
                                        </ol>
                                        <h1>Explore</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div id="content" class="no-top no-bottom">
                    {
                        this.concerts.Explore.map(function (item, index) {
                            return <section class="side-bg">
                                <div class="col-md-12 col-md-offset-12 pull-right image-container">
                                    <div class="background-image"></div>
                                </div>

                                <div class="container">
                                    <div class="row">
                                        <div className={"col-md-12 "+ (Math.abs(index%2)!=0 ? 'col-md-offset-7' : '')}>
                                            <div class="inner-padding">
                                                <h2>{item.Title}</h2>
                                                {item.Description}
                                                <div class="small-border"></div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </section>;
                        })
                    }
                </div>
                <AppFooter data={this.concerts} />
                <div id="go-top"><i class="fa fa-angle-up fa-2x"></i></div>

            </div>
        )
    }
}
export default Explore;


// WEBPACK FOOTER //
// ./src/components/Explore.js